import { instance } from "@/apis";
import { useQuery } from "@tanstack/react-query";

// TODO: API Docs 적용이 안되어있음
const useAccountInfoQuery = () => {
  return useQuery({
    queryKey: ["account-info"],
    queryFn: async () => instance.get(`api/v2/adaptor/account/info`),
    select: (data) => ({
      ...data.data.data,
      isSaaS: !data.data.data.isSaaS,
    }),
  });
};

export default useAccountInfoQuery;
